import React from 'react';

function Index(props) {
  const dataImage = [
    "data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 256 256' style='enable-background:new 0 0 256 256;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%230E141E;%7D .st1%7Bfill:%23FFFFFF;%7D .st2%7Bfill:%2300EA64;%7D%0A%3C/style%3E%3Crect x='0' y='0' class='st0' width='256' height='256'/%3E%3Cg%3E%3Cpath class='st1' d='M125.39,85.35h-19.26c-0.65,0-1.18,0.53-1.18,1.18v30.61H84.2V86.54c0-0.65-0.53-1.18-1.18-1.18H63.76 c-0.65,0-1.18,0.53-1.18,1.18v82.85c0,0.65,0.53,1.18,1.18,1.18h19.26c0.65,0,1.18-0.53,1.18-1.18v-30.61h20.75v30.61 c0,0.65,0.53,1.18,1.18,1.18h19.26c0.65,0,1.18-0.53,1.18-1.18V86.54C126.57,85.88,126.04,85.35,125.39,85.35z'/%3E%3Cpath class='st2' d='M199.76,170.57h-61.64c-0.65,0-1.18-0.53-1.18-1.18V86.53c0-0.65,0.53-1.18,1.18-1.18h61.64 c0.65,0,1.18,0.53,1.18,1.18v82.85C200.94,170.04,200.41,170.57,199.76,170.57z'/%3E%3C/g%3E%3C/svg%3E%0A",
    'https://dicoding-web-img.sgp1.cdn.digitaloceanspaces.com/original/commons/new-ui-logo.png',
    'https://buildwithangga.com/themes/front/images/logo_bwa_new.svg',
  ];

  return (
    <div className="relative bg-white border border-gray-200 hover:shadow-lg transition-all duration-300 p-4 rounded-lg pb-12">
      <div className="absolute bottom-2 right-4 text-xs font-light text-gray-700">
        {props.item.date}
      </div>
      <div className="relative">
        <div
          className="relative cursor-pointer"
          onClick={() => props.handlerClick(props.item)}>
          {props?.item?.image?.includes('.pdf') ? (
            <iframe
              //   sandbox="allow-scripts allow-modal"
              loading="eager"
              src={props.item.image}
              width="100%"
              className="w-full cursor-pointer overflow-hidden pointer-events-none rounded-md border border-gray-200"
              title={props.item.image}></iframe>
          ) : (
            <img
              src={props.item.image}
              alt={props.item.name}
              className="w-full h-40 object-cover object-top rounded-md border border-gray-200"
            />
          )}
        </div>

        <div className="relative flex gap-3 items-start mt-6">
          <img
            src={
              props.item.institution === 'Dicoding'
                ? dataImage[2]
                : props.item.institution === 'HackerRank' ||
                  props.item.institution === 'HR'
                ? dataImage[0]
                : dataImage[1]
            }
            alt={props.item.uniqueKey}
            className="relative h-12"
          />

          <div className="relative flex flex-col">
            <h1 className="text-base font-medium leading-relaxed text-gray-800">
              {props.item.name}
            </h1>
            <h4 className="text-sm font-light text-gray-500 leading-relaxed">
              {props.item.institution}
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(Index);
